import type { Xinglet } from '@xing-com/crate-xinglet';

import { App } from './app';

export default class RecommendationPage implements Xinglet {
  public getComponent() {
    return () => <App />;
  }
}
